import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateAcademicYearForm from "../../forms/CreateOrUpdateAcademicYearForm";

interface CreateAcademicYearModalProps {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  error: string | null;
}

const CreateAcademicYearModal: React.FC<CreateAcademicYearModalProps> = ({
  open,
  onClose,
  loading,
  error,
}) => {
  return (
    <AppModal
      open={open}
      onClose={onClose}
      title="Create New Academic Year"
      width="sm"
      loading={loading}
    >
      <CreateOrUpdateAcademicYearForm loading={loading} error={error} />
    </AppModal>
  );
};

export default CreateAcademicYearModal;
